import React from "react";
import { connect } from "react-redux";
import { Field, reduxForm, change } from "redux-form";
import { Link } from "react-router-dom";

import "./NewForm.css"

import history from "../../../../history";
import { newForm, getForm, editForm } from "../../../../actions/formsActions";

import Form from "../../../CustomViews/Form";

const FormForm = reduxForm({ form: "formForm" })(Form);

class NewForm extends React.Component {
    componentDidMount() {
        if (this.props.mode === "edit") this.props.getForm(this.props.match.params.formID);
    }

    componentDidUpdate() {
        if (this.props.currentUser.userID && this.props.currentUser.ouID !== +process.env.REACT_APP_HR_OU_ID) history.push("/");
        else if (this.props.mode === "edit" && this.props.currentForm.formID) {
            this.props.change("formForm", "title", this.props.currentForm.title);
            this.props.change("formForm", "description", this.props.currentForm.description);
        }
    }

    onSubmit = (formValues, onFormError) => {
        const formData = new FormData();
        if (formValues.title) formData.append("title", formValues.title);
        if (formValues.description) formData.append("description", formValues.description);
        if (formValues.formFile) formData.append("formFile", formValues.formFile);
        if (this.props.mode === "edit") this.props.editForm(this.props.match.params.formID, formData, onFormError);
        else this.props.newForm(formData, onFormError);
    };

    onFileChange = (event, input) => {
        event.preventDefault();
        input.onChange(event.target.files[0]);
    };

    renderFileInput = ({ input, type, mime }) => {
        return (
            <input
                name={input.name}
                type={type}
                accept={mime}
                onChange={event => this.onFileChange(event, input)}
            />
          );
    };

    renderFieldError = (name, formErrors, renderError) => {
        const error = formErrors.filter(err => err.field === name)[0];
        return renderError(error);
    };

    renderFields = (_, __, ___, renderInput, formErrors, renderError) => {
        return (
            <React.Fragment>
                <div className="ui segments">
                    <div className="ui segment">
                        <div className="ui header">
                            <i className="pdf file icon"></i>
                            {this.props.mode === "edit" ? "Edycja formularza" : "Nowy formularz"}
                        </div>
                    </div>
                    <div className="ui segment">
                        <div className="ui grid">
                            <div className="one column row">
                                <div className="column">
                                    <div className="content">
                                        <b>{this.props.mode === "edit" ? "Nowy tytuł" : "Tytuł"}</b><br />
                                        <Field type="text" name="title" component={renderInput} placeholder="Wpisz tytuł..." />
                                        {this.renderFieldError("title", formErrors, renderError)}
                                    </div>
                                </div>
                            </div>
                            <div className="one column row">
                                <div className="column">
                                    <div className="content">
                                        <b>{this.props.mode === "edit" ? "Nowy opis" : "Opis"}</b><br />
                                        <Field type="text" name="description" maxLength="1000" component="textarea" placeholder="Wpisz opis..." />
                                        {this.renderFieldError("description", formErrors, renderError)}
                                    </div>
                                </div>
                            </div>
                            <div className="one column row">
                                <div className="column">
                                    <div className="content">
                                        <b>{this.props.mode === "edit" ? "Nowy plik PDF formularza (opcjonalnie)" : "Plik PDF formularza"}</b><br />
                                        <Field type="file" name="formFile" mime="application/pdf" component={this.renderFileInput} placeholder="Załącz plik..." />
                                        {this.renderFieldError("formFile", formErrors, renderError)}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <button className="ui button primary">Zatwierdź</button>
            </React.Fragment>
        );
    };

    render() {
        return (
            <React.Fragment>
                <div className="new-form-component ui container">
                    {this.props.currentUser.ouID === +process.env.REACT_APP_HR_OU_ID ? (
                        <React.Fragment>
                            <div className="ui two item menu">
                                <Link to="/forms" className="item">
                                    <div className="content">Lista formularzy</div>
                                </Link>
                                <Link to={`/forms/${this.props.mode === "edit" ? `edit/${this.props.match.params.formID}` : "new"}`} className="active item">
                                    <div className="content">{this.props.mode === "edit" ? "Edycja formularza" : "Nowy formularz"}</div>
                                </Link>
                            </div>
                            <div className="ui divider" />
                        </React.Fragment>
                    ) : null}
                    <div className="ui container">
                        <FormForm onSubmit={this.onSubmit} renderFields={this.renderFields} />
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => ({
    currentUser: state.user.current,
    currentForm: state.forms.current
});

export default connect(mapStateToProps, { newForm, getForm, editForm, change })(NewForm);